// extracted by mini-css-extract-plugin
export default {"boardView":"Board-module__boardView--IHXJN"};